(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piclu-pet-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const canAnimate = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canTilt = canAnimate && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const observer = canAnimate && 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 })
      : null;

    const init = (scope = document) => {
      scope.querySelectorAll('[data-piclu-about]:not([data-piclu-about-bound])').forEach(section => {
        section.setAttribute('data-piclu-about-bound', '');
        if (observer) {
          section.classList.add('is-ready');
          observer.observe(section);
        }
        const card = section.querySelector('[data-piclu-about-tilt]');
        if (!card) return;
        card.addEventListener('pointerdown', event => {
          if (!canAnimate || event.pointerType !== 'touch') return;
          card.style.setProperty('--piclu-about-rx', '-2deg');
          card.style.setProperty('--piclu-about-ry', '2deg');
        });
        const resetTouch = () => {
          card.style.removeProperty('--piclu-about-rx');
          card.style.removeProperty('--piclu-about-ry');
        };
        card.addEventListener('pointerup', resetTouch);
        card.addEventListener('pointercancel', resetTouch);
        if (!canTilt) return;
        let frame = 0;
        card.addEventListener('pointermove', event => {
          if (frame) cancelAnimationFrame(frame);
          const { left, top, width, height } = card.getBoundingClientRect();
          const x = (event.clientX - left) / width - .5;
          const y = (event.clientY - top) / height - .5;
          frame = requestAnimationFrame(() => {
            card.style.setProperty('--piclu-about-rx', `${(-y * 5).toFixed(2)}deg`);
            card.style.setProperty('--piclu-about-ry', `${(x * 5).toFixed(2)}deg`);
            frame = 0;
          });
        });
        card.addEventListener('pointerleave', () => {
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          card.style.removeProperty('--piclu-about-rx');
          card.style.removeProperty('--piclu-about-ry');
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piclu-pet-discover"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const pointer=matchMedia('(hover:hover) and (pointer:fine)');
 const bound=new WeakSet();
 function init(){document.querySelectorAll('[data-piclu-preview-card]').forEach(card=>{
  if(bound.has(card))return;bound.add(card);let frame=0;
  card.addEventListener('pointermove',event=>{
   if(event.pointerType!=='mouse'||motion.matches||!pointer.matches)return;
   cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const box=card.getBoundingClientRect();const x=(event.clientX-box.left)/box.width-.5;const y=(event.clientY-box.top)/box.height-.5;card.style.setProperty('--piclu-rx',`${-y*4}deg`);card.style.setProperty('--piclu-ry',`${x*4}deg`);});
  });
  card.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);card.style.removeProperty('--piclu-rx');card.style.removeProperty('--piclu-ry');});
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
